import $ from 'jquery';

const header = () => {
  const el = $('.js-header');
  const $body = $('body');
  const $win = $(window);

  if (el.length) {
    $win.on('scroll', () => {
      if ($win.scrollTop() > el.height() * 1.5) {
        $body.addClass('scrolled');
        $body.css({ paddingTop: el.height() });
        el.addClass('anim-in');
      } else {
        el.removeClass('anim-in');
        $body.removeClass('scrolled');
        $body.removeAttr('style');
      }
    });
  }

  $('.disable-click > a').on('click', ev => {
    ev.preventDefault();
    return false;
  });
};
export default header;



// WEBPACK FOOTER //
// ./src/scripts/modules/header.js